const size = {
  md: "600px",
  lg: "1024px",
};

export const screen = {
  tablet: `(min-width: ${size.md})`,
  desktop: `(min-width: ${size.lg})`,
};
